import { render, staticRenderFns } from "./menu4_images_scence_q.vue?vue&type=template&id=190bffd0&scoped=true"
import script from "./menu4_images_scence_q.vue?vue&type=script&lang=js"
export * from "./menu4_images_scence_q.vue?vue&type=script&lang=js"
import style0 from "./menu4_images_scence_q.vue?vue&type=style&index=0&id=190bffd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190bffd0",
  null
  
)

export default component.exports